// extracted by css-extract-rspack-plugin
export default {"ToggleContent":"xMTy2","isReadOnly":"jE6Oa"};